import { render, staticRenderFns } from "./prevOrNext.vue?vue&type=template&id=d0de1862&scoped=true&"
import script from "./prevOrNext.vue?vue&type=script&lang=js&"
export * from "./prevOrNext.vue?vue&type=script&lang=js&"
import style0 from "./prevOrNext.vue?vue&type=style&index=0&id=d0de1862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0de1862",
  null
  
)

export default component.exports